import { Injectable } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { Observable } from 'rxjs';

@Injectable()
export class LaboratoryService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<Laboratory[]> => {
    return this.apiHttp.get<Laboratory[]>("laboratories");
  };

  public get = (id: number): Observable<Laboratory> => {
    return this.apiHttp.get<Laboratory>(`laboratories/${id}`);
  };
}

export interface Laboratory {
  id: number;
  name: string;
  isActive: boolean;
  assays: Assay[];
}

export interface Assay {
  id: number;
  name: string;
  isActive: boolean;
  laboratoryId: number;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/laboratory.service.ts